const CLEAR_RETRACTION = (state) => {
  state.retractionItem = undefined;
  state.retractionErrors = [];
};

export default CLEAR_RETRACTION;
